import PropTypes from 'prop-types';

import FavoriteCount from '@spotahome/ui-library/src/tenant/components/FavoriteCount';

import { useFavorite } from '@spotahome/ui-library/src/tenant/context/FavoriteContext';

const FavoriteButton = ({ className = '', isRedesign = false }) => {
  const { isFavorite, favoritesCount, toggleFavorite } = useFavorite({
    section: 'listing',
    pageType: 'product_page'
  });

  return (
    <FavoriteCount
      onClick={toggleFavorite}
      selected={isFavorite}
      className={className}
      count={favoritesCount}
      isRedesign={isRedesign}
    />
  );
};

FavoriteButton.propTypes = {
  className: PropTypes.string,
  isRedesign: PropTypes.bool
};

export default FavoriteButton;
